import { render, staticRenderFns } from "./AppDocs.vue?vue&type=template&id=1ac8d16f&scoped=true&"
import script from "./AppDocs.vue?vue&type=script&lang=js&"
export * from "./AppDocs.vue?vue&type=script&lang=js&"
import style0 from "./AppDocs.vue?vue&type=style&index=0&id=1ac8d16f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8d16f",
  null
  
)

export default component.exports